import { dew as _setDew } from "./set";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.set = void 0;
  var set_1 = _setDew();
  Object.defineProperty(exports, "set", {
    enumerable: true,
    get: function () {
      return set_1.set;
    }
  });
  return exports;
}